/**
 * Feature flags (doc 11).
 *
 * A compile-time constant, not a runtime setting: there is nothing to configure
 * yet, and a database-backed flag for a feature with no implementation would be
 * ceremony. The backend enforces the same thing independently — writing a
 * license for a disabled app is a 422 regardless of what this file says.
 */
export interface FeatureFlags {
  onboarding: boolean;
}

export const FEATURES: FeatureFlags = {
  onboarding: false,
};
